/**
 * Session timeout configuration for ISO 27001 compliance
 *
 * IDLE_TIMEOUT: Maximum time of user inactivity before automatic logout
 * MAX_SESSION_DURATION: Maximum total session time regardless of activity
 * WARNING_PERIOD: Time before timeout to show warning modal (in milliseconds)
 */

// Session timeout values (in seconds)
export const IDLE_TIMEOUT = 30 * 60; // 30 minutes of inactivity
export const MAX_SESSION_DURATION = 12 * 60 * 60; // 12 hours total session time

// Warning period before timeout (in milliseconds)
export const WARNING_PERIOD = 1 * 60 * 1000; // 1 minute before timeout

// FOR PURPOSE OF DEMONSTRATING SESSION TIMEOUT
//export const IDLE_TIMEOUT = 0.5 * 60; // 30 seconds of inactivity
//export const WARNING_PERIOD = 0.5 * 60 * 1000; // 30 seconds before timeout

// Heartbeat interval: how often to ping the backend while the user is active.
// Keeps server-side lastActivityAt alive during long frontend-only workflows
// (e.g. multi-trade booking modal) where no API calls are made for 30+ minutes.
// Only fires when real DOM activity has been detected within this window.
export const HEARTBEAT_INTERVAL = 10 * 60 * 1000; // 10 minutes in milliseconds

// Events that count as user activity
export const ACTIVITY_EVENTS = [
  'mousedown',
  'mousemove',
  'keypress',
  'scroll',
  'touchstart',
  'click',
] as const;

export const SESSION_TIMEOUT_CONFIG = {
  idleTimeout: IDLE_TIMEOUT,
  maxSessionDuration: MAX_SESSION_DURATION,
  warningPeriod: WARNING_PERIOD,
  activityEvents: ACTIVITY_EVENTS,
};
